/* eslint-disable camelcase */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual } from 'lodash';
import PlaidLink from 'react-plaid-link';

class PlaidWidget extends Component {
	shouldComponentUpdate({ language }) {
		const lastProps = this.props;

		return !isEqual(language, lastProps.language);
	}

	render() {
		const {
			env, public_key, product, language, onSuccess, onExit,
		} = this.props;

		return (
			<PlaidLink
				clientName="RollKall"
				env={env}
				product={product}
				publicKey={public_key}
				onExit={onExit}
				onSuccess={onSuccess}
				language={language}
			>
				<div className="text-center padding-10">
					<i className="rkf rkf-police-office font-size-36" />
					<div className="margin-top-10 text-primary">Click Here</div>
					<div>to link your bank account</div>
				</div>
			</PlaidLink>
		);
	}
}

PlaidWidget.propTypes = {
	env        : PropTypes.string.isRequired,
	public_key : PropTypes.string.isRequired,
	onSuccess  : PropTypes.func.isRequired,
	onExit     : PropTypes.func,
	product    : PropTypes.array,
	language   : PropTypes.string,
};

PlaidWidget.defaultProps = {
	product  : ['auth'],
	language : 'en',
	onExit   : () => {},
};

export default PlaidWidget;
